import { request } from './request';

export { commissionsummarys };

/**
 *
 * @param {*} Keyword
 * @returns
 */
const commissionsummarys = (Keyword) => {
  return request({
    url: '/Commission/GetCommissionSummaries',
    method: 'get',
    params: {
      Keyword,
    },
  });
};
